import appConfig from '@/../app.config';

export default () => {
    if (process.env.NODE_ENV !== 'production') {
      appConfig.APIUrl = process.env.API_URL;
      appConfig.Theme = process.env.THEME;
      appConfig.SiteUrl = process.env.SITE_URL;
      appConfig.PublicSiteUrl = process.env.PUBLIC_SITE_URL;
      appConfig.MemberAreaSiteUrl = process.env.MEMBER_AREA_SITE_URL;
      appConfig.GoogleTagManagerId = process.env.GOOGLE_TAGMANAGER_ID;
      appConfig.TrackerClientDSNKey = process.env.TRACKER_CLIENT_DSN_KEY;
    }

    return appConfig;
};




// WEBPACK FOOTER //
// ./src/components/plugins/AppConfig/configProvider.js